/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";

export class NsIronSolrQuery extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();
  }

  static get is() {
    return "ns-iron-solr-query";
  }

  static get properties() {
    return {
      field: {
        type: String,
        value: "",
        observer: "_setField"
      },
      collection: {
        type: String,
        value: "rec"
      },
      enableWildcardSearch: {
        type: Boolean,
        value: false,
        observer: "_setField"
      },
      enableFuzzySearch: {
        type: Boolean,
        value: false,
        observer: "_setField"
      },
      /*
            filter example:
            {
                country:"ar can"
            }
            would only allow matches with country as "ar" or "can"
            */
      filter: {
        type: Object,
        observer: "_setParams"
      },
      host: {
        type: String,
        value: "https://devgw.mynuskin.com/mec/solr"
      },
      port: {
        type: String,
        value: 8983
      },

      /* pagination configuration
                howMany: number of results returned per request
                pagination: page of results returned
             */
      howMany: {
        type: Number,
        value: 30
      },
      pagination: {
        type: Number,
        value: 0,
        notify: true,
        observer: "_setPage"
      },

      // enables logs of functions
      debug: {
        type: Boolean,
        value: false
      },

      // Variables below are not to be configured
      _hasParamsChanged: {
        type: Boolean,
        value: false
      },
      _query: String,
      _queryString: String,
      response: {
        type: Array,
        notify: true,
        reflectToAttribute: true
      },
      clientid: {
        type: String,
        value: "34bbbd1df8a946068d19eec5f92c76bd"
      },
      clientsecret: {
        type: String,
        value: "3a6b7b98e4e647ed9E278EACA3A8BF9D"
      },
      badgeTranslationMap: {
        type: String,
        value: [{}]
      },
      currentlySearching: {
        type: String,
        value: "false",
        notify: true
      },
      translationFound: {
        type: Boolean,
        value: false
      },
      countryCodeTranslationMap: {
        type: Array,
        value: []
      }
    };
  }

  doQuery() {
    if (this.currentlySearching === "false") {
      this._setUrl();
      this.currentlySearching = "true";
      $.ajax({
        type: "GET",
        url: this._url,
        headers: {
          client_id: this.clientid,
          client_secret: this.clientsecret
        },
        contentType: "application/json",
        dataType: "json",
        success: (data) => this._handleResponse(data),
        error: (err) => this._handleErrorResponse(err)
      });
    }
  }

  query(query) {
    if (typeof query === "undefined" || query === null) return;
    if (this._query !== query) {
      this._query = query;
      this._setQueryString(query);
      this.doQuery();
    } else {
      this.doQuery();
    }
  }

  _setParams() {
    if (this.debug) {
      console.log("function: setParams");
    }

    this._params = "?q=" + this._queryString + "&wt=json&rows=" + this.howMany;

    if (this.pagination && this.pagination !== 0) {
      this._params += "&start=" + this.pagination * this.howMany;
    }
    if (this.filter) {
      let fq = "&fq=";
      for (let key in this.filter) {
        if (this.filter.hasOwnProperty(key)) {
          if (this.filter[key].indexOf(" ") === -1) {
            this._params += fq + key + ":" + this.filter[key];
          } else {
            let strArr = this.filter[key].split(" ");
            for (let i = 0; i < strArr.length; i++) {
              let word = strArr[i];
              if (word !== "") {
                this._params += fq + key + ":" + this.filter[key];
              }
            }
          }
        }
      }
    }
    this._hasParamsChanged = true;
    if (this.debug) {
      console.log("params: ", this._params);
    }
  }

  _setUrl() {
    if (this.debug) {
      console.log("function: _setUrl");
    }

    this._hasParamsChanged = false;
    this._url = this.host + "/" + this.collection + "/select" + this._params;

    if (this.debug) {
      console.log("url: ", this._url);
    }
  }

  _handleResponse(data) {
    if (this.debug) {
      console.log("function: _handleResponse in ns-iron-solr-query");
    }
    try {
      this.set("response", data.response.docs);
    } catch (e) {
      console.log("Query failed.", e);
    }

    if (this.debug) {
      console.log("response:", this.response);
      console.log("arguments: ", arguments);
    }
    this.currentlySearching = "false";
  }

  _handleErrorResponse(err) {
    if (this.debug) {
      console.log("function: handleErrorResponse");
    }

    if (this.debug) {
      console.log(err);
    }

    this.response = err;
    this.currentlySearching = "false";
  }

  _setQueryString(query) {
    let isIE = navigator.userAgent.indexOf("Trident") > -1;
    if (typeof query === "undefined") {
      query = "";
    }
    // not escaping special characters
    if (query.match(/[+\-!(){}[\]^"~*?:/]|&&|\|\|/) !== null) {
      if (this.debug) {
        console.log("_setQueryString stopped. ", query, "not allowed");
      }
      return;
    }
    try {
      if (query === "") {
        this._queryString = "*:*";
      } else {
        // Check to see if the field is title or if the field isn't defined.
        if (this.field === "titles" || !this.field) {
          query = this._checkBadgeTranslations(query);
        }
        if (this.field === "country" || !this.field) {
          query = this._checkCountryTranslations(query);
        }
        if (this.field) {
          this._queryString = this.field + ":";
        } else {
          this._queryString = "";
        }
        if (query.indexOf(" ") === -1 && !this.translationFound) {
          this._queryString += '"' + query + '"';
        } else {
          // TODO Horrible hack to get localized badge title searches working in time. Should definitely be revisited.
          // TODO They break if they have a " surrounding the query.
          if (!this.translationFound) {
            this._queryString += '"';
          }
          if (!isIE) {
            let isFirst = true;
            query = query.replace(/&/g, "%26");
            let strArr = query.split(" ");
            for (let i = 0; i < strArr.length; i++) {
              let word = strArr[i];
              if (word !== "") {
                if (isFirst) {
                  isFirst = false;
                  this._queryString += word;
                } else {
                  this._queryString += "%20" + word;
                }
              }
            }
          } else {
            this._queryString += query;
          }
          // TODO Horrible hack to get localized badge title searches working in time. Should definitely be revisited.
          // TODO They break if they have a " surrounding the query.
          if (!this.translationFound) {
            this._queryString += '"';
          }
        }
        if (!this.translationFound && isIE) {
          this._queryString = encodeURIComponent(this._queryString);
        }
      }
      this._setParams();
    } catch (e) {
      this._handleErrorResponse(e);
    }
  }

  _setField() {
    this._setQueryString(this._query);
  }

  _setPage(newPagination, oldPagination) {
    // if we click the search button then newPagination will equal 0.  don't execute this function when that's the case.
    if (newPagination !== 0) {
      this._setParams();
      this.query(this._params);
    }
  }

  _checkBadgeTranslations(query) {
    let translations = [];
    for (let i = 0; i < this.badgeTranslationMap.length; i++) {
      let containsTranslation = false;
      if (
        this.badgeTranslationMap[i] &&
        this.badgeTranslationMap[i].translations
      ) {
        containsTranslation = this.badgeTranslationMap[i].translations.some(
          (translation) => {
            return (
              translation.toLocaleUpperCase() === query.toLocaleUpperCase()
            );
          }
        );
      }
      if (containsTranslation) {
        if (/\d/.test(query)) {
          let num = query.match(/\d+/)[0];
          translations.push(num + this.badgeTranslationMap[i].code);
        } else {
          translations.push("*" + this.badgeTranslationMap[i].code);
        }
      }
    }
    if (translations.length) {
      this.translationFound = true;
      return translations.join(" OR ").replace(/^"(.*)"$/, "$1");
    } else {
      this.translationFound = false;
      return query;
    }
  }

  _checkCountryTranslations(query) {
    for (let i = 0; i < this.countryCodeTranslationMap.length; i++) {
      let containsTranslation = false;
      if (
        this.countryCodeTranslationMap[i] &&
        this.countryCodeTranslationMap[i].translations
      ) {
        containsTranslation = this.countryCodeTranslationMap[
          i
        ].translations.some((translation) => {
          return translation.toLocaleUpperCase() === query.toLocaleUpperCase();
        });
      }
      if (containsTranslation) {
        return this.countryCodeTranslationMap[i].code;
      }
    }
    return query;
  }
}

customElements.define(NsIronSolrQuery.is, NsIronSolrQuery);
